import * as React from 'react';

import { CommonStyles } from '../../../common/react/CommonStyles';

const panelStyle: React.CSSProperties = {
  height: 240,
  width: 260,
  position: 'relative'
};

const imgStyle: React.CSSProperties = {
  marginRight: 'auto',
  marginLeft: 'auto',
  height: 120,
  display: 'block',
  cursor: 'pointer'
};

const contentStyle: React.CSSProperties = {
  marginTop: CommonStyles.Sizes.MediumSpace
};

const callToActionStyle: React.CSSProperties = {
  textAlign: 'center',
  position: 'absolute',
  bottom: '0',
  width: '100%',
  color: CommonStyles.Colors.DimensionBlueDark,
  cursor: 'pointer'
};

export class GuidePanel extends React.Component<GuidePanel.Props, GuidePanel.State> {
  public render() {
    return (
      <div className="tb-guide-panel" style={panelStyle} >
        <span onClick={this.props.callback}> <img src={this.props.imgUrl} style={imgStyle} /> </span>
        <p style={contentStyle} className="tb-guide-panel-text" > {this.props.content} </p>
        <span className="tb-guide-panel-action" style={callToActionStyle} onClick={this.props.callback}> {this.props.callToActionText} </span>
      </div>
     );
  }
}

export module GuidePanel {

  export interface Props {
    imgUrl: string;
    content: string;
    callback?: () => void;
    callToActionText: string;
    callToActionUrl?: string;
  }

  export interface State {}
}
